function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import PaginationVue from '@/components/PaginationVue';
import { useCaseMixin } from '@/apps/attributes/mixins/use_case_mixin';
import { mapState, mapMutations } from 'vuex';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { ARRAY_TYPE_ELEMENTS, TYPE_ELEMENTS, ROLES_LIST, GA_EVENTS } from '@/js/constants';
export default {
  name: 'SandboxRequestDetailComponent',
  components: {
    PaginationVue: PaginationVue
  },
  data: function data() {
    var itemsPerPage = 5;
    return {
      responseRequest: '',
      // companyName: '',
      search: '',
      value: 0,
      interval: 0,
      exitoResponse: 0,
      itemsPerPage: itemsPerPage,
      pagination: {
        current: 1,
        limit: itemsPerPage,
        total: 0
      },
      versionAttributes: [],
      attributes: [],
      keyTable: 1,
      businessAreas: [],
      grupo: [],
      partitionsByTable: [],
      unique_columns_val: [],
      // > si la solicitud SOLICITADO corresponde a una exportación base
      //   (desencriptar id_sandbox), aquí se guarda la fila pendiente
      baseExport: null,
      // > estado de una solicitud de "agregar base" pendiente, tal como lo clasifica el
      //   backend: { stage: 'awaiting_approval' | 'validating' | 'none', table,
      //   invalid_columns }. No sale de attribute_base_export (esa tabla es exclusiva de
      //   exportar base) sino del historial de estados del caso de uso.
      baseRequest: null,
      // > hasta que las consultas responden no se sabe en cuál de los tres escenarios
      //   estamos, así que los botones esperan (si no, un clic rápido cae en el re-envío)
      baseGateLoaded: false,
      // > motivo por el que el caso quedó en estado SOLICITADO (último log de estado)
      statusReason: ''
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  mixins: [useCaseMixin],
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _this = this;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            this.unique_columns_val = [];
            this.getUseCase(this.item.company_code).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return _this.getAttributes().then(function () {
                      console.log(_this.attributes, 'attributes000000');
                    });
                  case 1:
                    _this.getBusinessAreas();
                  case 2:
                    return _context.a(2);
                }
              }, _callee);
            })));
            this.loadPendingBaseExport();
            this.loadStatusReason();

            // this.companyName = this.companyAbrevs[this.companyCode]
          case 1:
            return _context2.a(2);
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading', 'setValue'])), {}, {
    validate: function validate() {
      return this.$refs.form.validate();
    },
    // > resuelve, para un caso ATHENA, cuál de los cuatro escenarios aplica, en orden:
    //   1. fila SOLICITADO en attribute_base_export → exportar base (desencriptar id_sandbox)
    //   2. base-request/pending = awaiting_approval → adición de base que falló la 1:1
    //   3. base-request/pending = validating        → la validación sigue corriendo
    //   4. nada de lo anterior                      → aprobación de la CREACIÓN de un sandbox
    //      IBK, que llega aquí porque SandboxRequest.vue marca source='ATHENA' para
    //      company_code='000'; ese caso debe seguir re-enviando la conversión completa.
    loadPendingBaseExport: function loadPendingBaseExport() {
      var _this2 = this;
      if (!this.item || !this.isAthenaUseCase) {
        // Caso BigQuery: no aplica el gate de base, los botones operan de inmediato.
        this.baseGateLoaded = true;
        return;
      }
      UseCasesService.ListBaseExports(this.item.id).then(function (response) {
        var records = response.data && response.data.records || [];
        // Status.SOLICITADO === 1
        _this2.baseExport = records.find(function (r) {
          return r.status_id === 1;
        }) || null;
        if (_this2.baseExport) {
          return null;
        }
        // El servicio devuelve el body {success, code, message, data}; el estado va en data.
        return UseCasesService.GetPendingBaseRequest(_this2.item.id).then(function (res) {
          _this2.baseRequest = res && res.data || null;
        });
      }).catch(function (err) {
        console.error('No se pudo cargar la solicitud de base pendiente:', err);
      }).finally(function () {
        _this2.baseGateLoaded = true;
      });
    },
    // > Bloquea Aprobar/Rechazar mientras no se sabe el escenario, o mientras la validación
    //   1:1 sigue corriendo. Sin esto el modal re-enviaba la conversión, que repetía la misma
    //   validación, volvía a fallar y devolvía el caso a SOLICITADO.
    baseRequestBlocked: function baseRequestBlocked() {
      if (!this.isAthenaUseCase) {
        return false;
      }
      if (!this.baseGateLoaded) {
        tasks.toast.warning('Cargando el estado de la solicitud, intenta en unos segundos.');
        return true;
      }
      if (this.baseRequestValidating) {
        tasks.toast.warning('La validación de esta base todavía está en curso. Espera a que termine para aprobar o rechazar.');
        return true;
      }
      return false;
    },
    // > carga el motivo por el que el caso quedó en estado SOLICITADO, tomando el último
    //   registro de estado SOLICITADO del historial (attribute_business_case_status).
    //   El motivo lo persiste el backend en description (validación fallida) o response.
    loadStatusReason: function loadStatusReason() {
      var _this3 = this;
      if (!this.item || !this.item.company_code || !this.item.id) {
        return;
      }
      UseCasesService.getLogs(this.item.company_code, this.item.id, {
        full: '1'
      }).then(function (response) {
        var records = response.data && response.data.records || [];
        // Status.SOLICITADO === 1
        var requested = records.filter(function (r) {
          return r.status_id === 1;
        }).sort(function (a, b) {
          return new Date(b.creation_date) - new Date(a.creation_date);
        });
        var latest = requested[0];
        if (latest) {
          _this3.statusReason = String(latest.description || latest.response || '').trim();
        }
      }).catch(function (err) {
        console.error('No se pudo cargar el motivo del estado SOLICITADO:', err);
      });
    },
    onSubmit: function onSubmit(event) {
      var _this4 = this;
      event.preventDefault();
      if (this.baseRequestBlocked()) {
        return;
      }
      // > Exportación base pendiente: aprobar reusa el payload original (gate real),
      //   evitando re-enviar la conversión y duplicar el registro.
      if (this.baseExport) {
        if (!this.validate()) {
          return;
        }
        this.$emit('approve');
        // Enviar solo las columnas seleccionadas (checkbox marcado): el backend reduce
        // el payload original a esta selección al reprocesar la exportación.
        var selectedColumns = this.attributes.filter(function (item) {
          return item.status;
        }).map(function (item) {
          return item.attribute_name;
        });
        UseCasesService.ApproveBaseExport(this.baseExport.id, {
          response: this.responseRequest,
          applicant: this.userEmail,
          columns: selectedColumns
        }).then(function () {
          tasks.toast.success(_this4.translate('success_messages.operation_success'), _this4.translate('titles.success'));
        }).catch(function (error) {
          console.error('Error al aprobar exportación base:', error);
          var errorMsg = _this4.translate('error_messages.error_general');
          if (error.response && error.response.data && error.response.data.detail) {
            errorMsg = error.response.data.detail;
          }
          tasks.toast.error(errorMsg, _this4.translate('titles.error'));
        }).finally(function () {
          _this4.$emit('close');
        });
        return;
      }
      // > Adición de base que no superó la validación 1:1: aprobar reconstruye el payload
      //   en el backend y omite la validación (ya revisada), en vez de re-enviar la
      //   conversión completa —que volvería a fallar y a duplicar los atributos.
      if (this.pendingBaseRequest) {
        if (!this.validate()) {
          return;
        }
        this.$emit('approve');
        var _selectedColumns = this.attributes.filter(function (item) {
          return item.status;
        }).map(function (item) {
          return item.attribute_name;
        });
        UseCasesService.ApprovePendingBaseRequest(this.useCase.id, {
          operator: this.userEmail,
          response: this.responseRequest,
          columns: _selectedColumns
        }).then(function () {
          tasks.toast.success(_this4.translate('success_messages.operation_success'), _this4.translate('titles.success'));
        }).catch(function (error) {
          console.error('Error al aprobar la adición de base:', error);
          var errorMsg = _this4.translate('error_messages.error_general');
          if (error.response && error.response.data && error.response.data.detail) {
            errorMsg = error.response.data.detail;
          }
          tasks.toast.error(errorMsg, _this4.translate('titles.error'));
        }).finally(function () {
          _this4.$emit('close');
        });
        return;
      }
      if (this.useCase.source == 'ATHENA') {
        console.log('ATHENA💫💫💫💫💫💫🎒🎒🎒');
        console.log("this.usecase", this.useCase);
        console.log("this.attributes", this.attributes);
        console.log("this.items", this.items);
        var existIdSanbox = this.attributes.some(function (item) {
          return item.attribute_name === 'id_sandbox';
        });
        var tableName = "";
        var businessName = this.useCase.business_name;
        // Solo los atributos seleccionados (checkbox marcado) deben crearse/validarse.
        var _atributesStatusTrue = this.attributes.filter(function (item) {
          tableName = item.attribute_object_name.replace("".concat(businessName, "_"), '');
          return item.status;
        });
        // columns debe reflejar la selección: el backend (aws-convert-partyid) usa
        // payload["columns"] tanto para validar (1:1/cardinalidad) como para crear la tabla.
        var columns = _atributesStatusTrue.map(function (item) {
          return item.attribute_name;
        });

        // Detectar si hay atributos externos
        var _hasExternal = _atributesStatusTrue.some(function (attr) {
          return attr.is_external === '1';
        });

        // Buscar el atributo marcado como partyid
        var partyIdAttr = _atributesStatusTrue.find(function (attr) {
          return attr.is_partyid === '1';
        });
        console.log('partyIdAttr: ', partyIdAttr);
        if (!partyIdAttr && existIdSanbox) {
          partyIdAttr = _atributesStatusTrue.find(function (attr) {
            return attr.attribute_name === 'id_sandbox';
          });
        }
        console.log('partyIdAttr: ', partyIdAttr);
        // La columna identidad (party_id / id_sandbox) es obligatoria para la conversión.
        if (!partyIdAttr) {
          tasks.toast.warning(this.translate('frases.party_id_required'));
          return;
        }
        // Validar que si hay atributos externos, también haya un partyid externo
        if (_hasExternal) {
          var hasExternalAndPartyId = _atributesStatusTrue.some(function (attr) {
            return attr.is_external === '1' && attr.is_partyid === '1';
          });
          if (!hasExternalAndPartyId) {
            tasks.toast.warning("No se ha encontrado el 'partyid' en los atributos externos.");
            return;
          }
        }
        var _params = {
          company_code_usr: this.useCase.company_code,
          company_name: this.useCase.company_name,
          append: true,
          flag_data_ext: '1',
          applicant: this.userEmail,
          // Solicitude id 3: Añadir base Sandbox
          solicitude_type_id: 3,
          rdetail: _atributesStatusTrue,
          call_approval_method: false
        };
        var data = {
          business_name: this.useCase.business_name,
          company_code: this.useCase.company_code,
          usecase_id: this.useCase.id,
          business_unit: this.useCase.business_area_user,
          table_name: tableName,
          params: _params,
          party_id: partyIdAttr.attribute_name,
          columns: columns,
          automatic_approve: true,
          creation_user: this.userEmail,
          access_deadline_date: this.useCase.access_deadline_date,
          convert_idsandbox: existIdSanbox
        };
        console.log('data: ', data);
        UseCasesService.postConvertPartyIdAWS(data).then(function (response) {
          console.log(response);
          tasks.toast.success(_this4.translate('success_messages.operation_success'), _this4.translate('titles.success'));
        }).catch(function (error) {
          console.error('Error al convertir Party ID en AWS:', error);
          var errorMsg = _this4.translate('error_messages.error_general');
          if (error.response && error.response.data && error.response.data.detail) {
            errorMsg = error.response.data.detail;
          }
          tasks.toast.error(errorMsg, _this4.translate('titles.error'));
        }).finally(function () {
          _this4.$emit('close');
        });
        return;
      }
      if (!this.validate()) {
        return;
      }
      console.log('this.attributes: ', this.attributes);
      var hasExternalAttribute = this.attributes.some(function (attribute) {
        return attribute.is_external === '1' && attribute.status;
      });
      var atributesStatusTrue = this.attributes.filter(function (attribute) {
        return attribute.status;
      });
      console.log('atributesStatusTrue: ', atributesStatusTrue);
      // remover atributos que no se necesitan
      atributesStatusTrue = atributesStatusTrue.map(function (attribute) {
        var newAttribute = _objectSpread({}, attribute);
        delete newAttribute.status;
        delete newAttribute.id;
        delete newAttribute.project_code;
        delete newAttribute.project_id;
        delete newAttribute.company_code;
        // delete newAttribute.company_code_usr
        delete newAttribute.attribute_view_name;
        delete newAttribute.is_enabled;
        delete newAttribute.version_id;
        return newAttribute;
      });
      // Validacion de Partyid in external attributes
      var hasExternal = atributesStatusTrue.some(function (attribute) {
        return attribute.is_external === '1';
      });
      if (hasExternal) {
        console.log('hasExternal', hasExternal);
        var _hasExternalAndPartyId = atributesStatusTrue.some(function (attribute) {
          return attribute.is_external === '1' && atributesStatusTrue.some(function (attr) {
            return attr.is_partyid === '1' && attr.is_external === '1';
          });
        });
        if (!_hasExternalAndPartyId) {
          console.log('No element with isExternal = true and partyId = true was found.');
          tasks.toast.warning("No se ha encontrado el 'partyid' en los atributos externos.");
          return;
        }
      } else {
        console.log('No element with isExternal = true was found.');
      }
      this.setShowLoading(true);
      this.startBuffer(0, 50);
      this.$emit('approve');
      console.log('this.useCase', this.useCase);
      console.log('atributesStatusTrue: ', atributesStatusTrue);
      var deadline = new Date(this.useCase.access_deadline_date);
      console.log("✅✅✅deadline", deadline);
      var today = new Date();

      // Normalizamos las horas para que no afecten al cálculo de días
      deadline.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      // Diferencia en milisegundos
      var diffTime = deadline - today;

      // Convertimos a días
      var expiration_days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      console.log("Quedan ".concat(expiration_days, " d\xEDas hasta la expiraci\xF3n."));
      var params = {
        create: true,
        company_name: this.companyName,
        response: 'Ok',
        operator: this.userEmail,
        updated: false,
        solicitude_type_id: 1,
        // company_code_usr: this.useCase.company_code,
        // append: false,
        flag_data_ext: hasExternalAttribute ? '1' : '0',
        applicant: this.useCase.owner_name,
        rdetail: atributesStatusTrue,
        expiration_days: expiration_days
      };
      console.log(params);
      UseCasesService.createSandbox(this.useCase.company_code, this.useCase.id, params).then(function (response) {
        console.log(response);
        if (_this4.$gtm.enabled() && window.dataLayer) {
          window.dataLayer.push({
            event: GA_EVENTS.SANDBOX_REQUEST_MANAGEMENT,
            sandbox_name: _this4.useCase.business_name,
            sandbox_company: _this4.useCase.organization,
            owner_email: _this4.stringToHash(_this4.useCase.owner_name),
            company_code: _this4.companyCode,
            attribute_count: _this4.useCase.attribute_count,
            hash_email: _this4.stringToHash(userInfo.email),
            status: 'approved',
            module: 'attributes_marketplace'
          });
        }
        // UseCasesService.updateAttributesUseCase(this.useCase.company_code, this.useCase.id, false, params).then(response => {
        //  console.log(response)
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
      }).finally(function () {
        _this4.value = 1;
      });
      this.setShowLoading(false);
    },
    onReject: function onReject(event) {
      var _this5 = this;
      event.preventDefault();
      if (this.baseRequestBlocked()) {
        return;
      }
      if (!this.validate()) {
        return;
      }
      this.$emit('reject');
      // > Exportación base pendiente: rechazar la solicitud y notificar al solicitante.
      if (this.baseExport) {
        UseCasesService.RejectBaseExport(this.baseExport.id, {
          response: this.responseRequest,
          applicant: this.userEmail
        }).then(function () {
          tasks.toast.success(_this5.translate('success_messages.sandbox_request_rejected'));
        }).catch(function (err) {
          console.error(err);
          tasks.toast.error(_this5.translate('error_messages.error_general'), _this5.translate('titles.error'));
        }).finally(function () {
          _this5.$emit('close');
        });
        return;
      }
      // > Adición de base pendiente: rechazar sobre la solicitud derivada del historial,
      //   que además notifica al solicitante nombrando la tabla.
      if (this.pendingBaseRequest) {
        UseCasesService.RejectPendingBaseRequest(this.useCase.id, {
          operator: this.userEmail,
          response: this.responseRequest
        }).then(function () {
          tasks.toast.success(_this5.translate('success_messages.sandbox_request_rejected'));
        }).catch(function (err) {
          console.error('Error al rechazar la adición de base:', err);
          var errorMsg = _this5.translate('error_messages.error_general');
          if (err.response && err.response.data && err.response.data.detail) {
            errorMsg = err.response.data.detail;
          }
          tasks.toast.error(errorMsg, _this5.translate('titles.error'));
        }).finally(function () {
          _this5.$emit('close');
        });
        return;
      }
      var params = {
        status_id: this.useCase.flag_sandbox_create === '0' ? 7 : 9,
        company_name: this.companyName,
        response: this.responseRequest,
        operator: this.userEmail,
        solicitude_type_id: this.useCase.last_version_id > 4 ? 4 : this.useCase.last_version_id
      };
      UseCasesService.updateStatusUseCase(this.useCase.company_code, this.useCase.id, params).then(function (response) {
        tasks.toast.success(_this5.translate('success_messages.sandbox_request_rejected'));
        if (_this5.$gtm.enabled() && window.dataLayer) {
          window.dataLayer.push({
            event: GA_EVENTS.SANDBOX_REQUEST_MANAGEMENT,
            sandbox_name: _this5.useCase.business_name,
            sandbox_company: _this5.useCase.organization,
            owner_email: _this5.stringToHash(_this5.useCase.owner_name),
            company_code: _this5.companyCode,
            attribute_count: _this5.useCase.attribute_count,
            hash_email: _this5.stringToHash(userInfo.email),
            status: 'rejected',
            module: 'attributes_marketplace'
          });
        }
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this5.translate('error_messages.error_general'), _this5.translate('titles.error'));
      }).finally(function () {
        _this5.$emit('close');
      });
    },
    startBuffer: function startBuffer(start, delay) {
      var _this6 = this;
      this.value = start;
      clearInterval(this.interval);
      this.interval = setInterval(function () {
        _this6.value += 1;
        _this6.onChangePercentage(_this6.value);
      }, delay);
    },
    onChangePercentage: function onChangePercentage(value) {
      this.$emit('onChangePercentage', value);
    },
    getAttributes: function () {
      var _getAttributes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this7 = this;
        var response1, versionDifference;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return UseCasesService.getAttributeRequest(this.useCase.company_code, this.useCase.id);
            case 1:
              response1 = _context3.v;
              console.log(response1);
              versionDifference = response1.data['attr-request'];
              this.unique_columns_val = response1.data['unique_columns_val'];
              if (versionDifference) {
                console.log("VERSION DIFFERENCE: ", versionDifference);
                this.attributes = versionDifference.map(function (item) {
                  console.log("THIS.USECASE: ✔️", _this7.useCase);
                  var matched = _this7.useCase.attributes.find(function (attr) {
                    return "".concat(attr.attribute_object_name, ".").concat(attr.attribute_name) === "".concat(item.attribute_object_name, ".").concat(item.attribute_name);
                  });
                  return {
                    attribute_name: item.attribute_name,
                    attribute_object_name: item.attribute_object_name,
                    attribute_scheme_name: item.attribute_scheme_name || '',
                    attribute_project_name: item.attribute_project_name || '',
                    attribute_description: matched ? matched.attribute_description : '',
                    attribute_category: matched ? matched.attribute_category : '',
                    attribute_dtype: matched ? matched.attribute_dtype : '',
                    is_partyid: matched ? matched.is_partyid : '0',
                    is_external: matched ? matched.is_external : '0',
                    attribute_source_id: matched ? matched.attribute_source_id : 1,
                    attribute_filters: matched ? matched.attribute_filters : {},
                    attribute_notnull: matched ? matched.attribute_notnull : '0',
                    company_code_usr: matched ? matched.company_code_usr : '',
                    status: true
                  };
                });
              } else {
                this.attributes = this.useCase.attributes;
                this.attributes = this.attributes.map(function (item) {
                  item.status = true;
                  return item;
                });
              }
              // } else {
              //   this.attributes = this.useCase.attributes
              //   this.attributes = this.attributes.map(item => {
              //     item.status = true
              //     return item
              //   })
              // }
              if (!(this.useCase.source.toLowerCase() !== 'athena')) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return this.getPeriods();
            case 2:
              this.attributes = this.attributes.map(function (item) {
                item.status = true;
                return item;
              });
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getAttributes() {
        return _getAttributes.apply(this, arguments);
      }
      return getAttributes;
    }(),
    changeStatus: function changeStatus(item) {},
    getPeriods: function () {
      var _getPeriods = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this8 = this;
        var partitionRequests, periodsByTable;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.setShowLoading(true);
              // Se agrupa por categorías y por tipo de dato, para filtrar
              this.grupo = Array.from(this.attributes.reduce(function (accumulator, item) {
                var key = "".concat(item.attribute_project_name, "-").concat(item.attribute_scheme_name, "-").concat(item.attribute_object_name, "-").concat(item.attribute_category);
                if (!accumulator.has(key)) {
                  accumulator.set(key, {
                    project_name: item.attribute_project_name,
                    scheme_name: item.attribute_scheme_name,
                    object_name: item.attribute_object_name,
                    category: item.attribute_category,
                    periods: item.attribute_filters.process_date
                  });
                }
                return accumulator;
              }, new Map()).values());

              // Definimos un arreglo con las promesas que hacen el request de las particiones de las tablas
              partitionRequests = [];
              periodsByTable = {};
              this.grupo.forEach(function (category) {
                console.log(category);
                console.log('category');
                var request = UseCasesService.getTablePartitionField(category.project_name, category.scheme_name, category.object_name);
                partitionRequests.push(request);
                periodsByTable[category.object_name] = category.periods;
              });
              Promise.all(partitionRequests).then(function (values) {
                values.forEach(function (value) {
                  var data = value.data.partition_info;
                  if (data.values !== null) {
                    var periodos = [];
                    value.data.partition_info.values.map(function (object) {
                      var periodo = {
                        id: object,
                        name: object
                      };
                      periodos.push(periodo);
                    });
                    periodos.sort(_this8.dynamicSort('-id'));
                    value.data.partition_info.values = periodos;
                    var table = data.table_id.split('.').pop();
                    _this8.partitionsByTable[table] = data;
                    // this.partitionsByTable[table].selection = []
                    _this8.partitionsByTable[table].selection = periodsByTable[table];
                  }
                });
              }).finally(function () {
                _this8.keyTable = _this8.keyTable + 1;
                _this8.setShowLoading(false);
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getPeriods() {
        return _getPeriods.apply(this, arguments);
      }
      return getPeriods;
    }(),
    onChangePartitions: function onChangePartitions(table) {
      var _this9 = this;
      this.attributes.forEach(function (element, index) {
        if (element.attribute_object_name === table) {
          var field = _this9.partitionsByTable[table].field;
          var selection = _this9.partitionsByTable[table].selection;
          _this9.attributes[index].attribute_filters = {};
          _this9.attributes[index].attribute_filters["".concat(field)] = selection;
        }
      });
    },
    dynamicSort: function dynamicSort(property) {
      var sortOrder = 1;
      if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a, b) {
        // La siguiente línea funciona con cadenas y números, puedes personalizarla según tus necesidades
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    }
  }),
  watch: {
    value: function value(val) {
      if (val === 50) {
        if (this.exitoResponse > 0) {
          this.value = 99;
        } else {
          this.value = 51;
          clearInterval();
          this.startBuffer(this.value, 100);
        }
        //  return
        // } else if (val === 75) {
        //   if (this.exitoResponse > 0) {
        //     this.value = 99
        //   } else {
        //     this.value = 76
        //     clearInterval()
        //     this.startBuffer(this.value, 1000)
        //   }
        //   return
        // } else if (val === 90) {
        //   if (this.exitoResponse > 0) {
        //     this.value = 99
        //   } else {
        //     this.value = 91
        //     clearInterval()
        //     this.startBuffer(this.value, 1000)
        //   }
        return;
      }
      if (val < 100) {
        tasks.lockScreen.lock();
        return;
      }
      this.value = 100;
      tasks.lockScreen.unlock();
      clearInterval(this.interval);
      tasks.toast.success(this.translate('success_messages.general_processing'));
      this.$emit('close');
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode'])), mapState('attribute', ['companyAbrevs'])), {}, {
    // > Los dos flujos AWS que pueden dejar un caso esperando decisión del admin:
    //   exportar base (fila en attribute_base_export) y añadir base (derivada del historial).
    isAthenaUseCase: function isAthenaUseCase() {
      return String(this.item && this.item.source || '').toUpperCase() === 'ATHENA';
    },
    pendingBaseRequest: function pendingBaseRequest() {
      return this.baseRequest && this.baseRequest.stage === 'awaiting_approval' ? this.baseRequest : null;
    },
    baseRequestValidating: function baseRequestValidating() {
      return !!(this.baseRequest && this.baseRequest.stage === 'validating');
    },
    invalidColumnsText: function invalidColumnsText() {
      var cols = this.pendingBaseRequest && this.pendingBaseRequest.invalid_columns || [];
      return cols.map(function (c) {
        return c.columna;
      }).filter(Boolean).join(', ');
    },
    rules: function rules() {
      var _this0 = this;
      return {
        period: [function (v) {
          return v.length > 0 || _this0.translate('reglas.period');
        }],
        response: [function (v) {
          return !!v || _this0.translate('reglas.response_required');
        }]
      };
    },
    headers: function headers() {
      return [{
        text: '',
        value: 'actions',
        align: 'center'
      }, {
        text: this.translate('table_attributes_use_case_detail.attribute'),
        value: 'attribute_name'
      }, {
        text: this.translate('table_attributes_use_case_detail.description'),
        value: 'attribute_description'
      }, {
        text: this.translate('table_attributes_use_case_detail.source'),
        value: 'attribute_source_id'
      }, {
        text: this.translate('table_attributes_use_case_detail.data_type'),
        value: 'attribute_dtype'
      }];
    },
    getColumnsValidation: function getColumnsValidation() {
      this.unique_columns_val_text = "";
      if (this.unique_columns_val.length > 0) {
        var cols = "";
        this.unique_columns_val.forEach(function (item) {
          if (cols != "") cols += ",";
          cols += item;
        });
        console.log(cols);
        this.unique_columns_val_text = cols != '' ? 'Se encontraron columnas que pueden tener valores únicos respecto al party_id: ' + cols : '';
        return cols != '' ? 'Se encontraron columnas que pueden tener valores únicos respecto al party_id: ' + cols : '';
      } else {
        return "";
      }
    }
  })
};